import { api, LightningElement, wire } from "lwc";
import { LabelsAdapter, LabelsAdapterValue } from "common/labelsAdapter";
import {
  CollectionConfig,
  PersonalizedLearningQuery,
  CollectionQuery,
} from "common/contentCollection";

import { defaultConfig } from "./config";
import type { CollectionChangeEvent } from "common/contentCollection";
import * as locales from "./locales";

export default class PersonalizedRecommendations extends LightningElement {
  @api config: CollectionConfig = defaultConfig;
  @api limit = 3;
  @api campaignName?: string;
  @api googleClientId?: string;

  @wire(LabelsAdapter, { locales })
  private labels: LabelsAdapterValue = {};

  private get configWithDefaults(): CollectionConfig {
    return {
      ...this.config,
      limit: this.limit,
      personalization: {
        ...this.config.personalization,
        campaignName:
          this.campaignName || this.config.personalization?.campaignName,
        googleClientId:
          this.googleClientId || this.config.personalization?.googleClientId,
      },
      card: {
        ...this.config.card,
        title: this.config?.card?.title || this.labels.title,
      },
    };
  }

  private _query!: PersonalizedLearningQuery;

  private get query(): CollectionQuery<unknown> | undefined {
    this._query = new PersonalizedLearningQuery({
      campaignName: this.configWithDefaults?.personalization?.campaignName,
      userContext: {
        googleClientId:
          this.configWithDefaults?.personalization?.googleClientId,
      },
      fallbackItems: this.configWithDefaults?.personalization?.fallbackItems,
      allowEnglishFallbacks:
        this.configWithDefaults?.personalization?.allowEnglishFallbacks,
    });
    return this._query;
  }

  private handleStateChange(e: CollectionChangeEvent) {
    this.dispatchEvent(new CustomEvent(e.type, { detail: e.detail }));
  }
}
